/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  GetApiV1DocumentCourseRegistrationAttachmentDownload401,
  GetApiV1DocumentCourseRegistrationAttachmentDownload403,
  GetApiV1DocumentCourseRegistrationAttachmentDownload404,
  GetApiV1DocumentCourseRegistrationAttachmentDownload500,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationAttachmentDownload.ts";

function getGetApiV1DocumentCourseRegistrationAttachmentDownloadUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/document/course-registration/attachment-download` as const,
  };
  return res;
}

/**
 * @description Gera e retorna uma URL assinada para download do arquivo anexado à pessoa. Retorna 403 caso o anexo não pertença ao usuário autenticado e 404 caso o anexo não seja encontrado. **(Requer Authorization para autenticação)**
 * @summary Retorna URL de download de um anexo de pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/document/course-registration/attachment-download}
 */
export async function getApiV1DocumentCourseRegistrationAttachmentDownload(
  params?: GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
    ResponseErrorConfig<
      | GetApiV1DocumentCourseRegistrationAttachmentDownload401
      | GetApiV1DocumentCourseRegistrationAttachmentDownload403
      | GetApiV1DocumentCourseRegistrationAttachmentDownload404
      | GetApiV1DocumentCourseRegistrationAttachmentDownload500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1DocumentCourseRegistrationAttachmentDownloadUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
